<div class="welcome container">
  <div class="stats row">
    <div class="col-sm-6">
      <a [routerLink]="routes.products">
        <mat-card appearance="outlined">
          <mat-card-title> Start-ups </mat-card-title>
          <mat-card-content>
            Anzahl registrierter Start-ups.
            <div style="font-size: 6rem">
              {{ stats?.totalStartups }}
            </div>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div *minPrivilege="'FULL'" class="col-sm-6">
      <div *ngIf="stats?.applications">
        <a [routerLink]="routes.products" [queryParams]="{statusIn: productStatusRequested, cycleFilter: stats?.applications?.cycle.uuid}">
          <mat-card appearance="outlined">
            <mat-card-title>Zum Freischalten</mat-card-title>
            <mat-card-content>
              Produkte mit angeforderter Freischaltung für Pitch: <em>{{ stats?.applications?.cycle.name }}</em>
              <div style="font-size: 6rem">
                {{ stats?.applications?.totalProductsRequested }}
              </div>
            </mat-card-content>
          </mat-card>
        </a>
      </div>
    </div>
    <div class="col-sm-6">
      <a [routerLink]="routes.cycles">
        <mat-card appearance="outlined">
          <mat-card-title>Countdown</mat-card-title>
          <mat-card-content>
            Anzahl der Tage bis zum nächsten Pitch
            <div style="font-size: 6rem">
              {{ daysUntilPitchDate }}
            </div>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div class="col-sm-6">
      <mat-card appearance="outlined" *minPrivilege="'FULL'">
        <mat-card-title>Andere Funktionen</mat-card-title>
        <mat-card-content>
          <ul class="extra-features">
            <li><a [routerLink]="routes.mailjetExport">Mailjet-Kontaktlisten-Export</a></li>
            <li><a [routerLink]="routes.registrationDebugger">Registrierungsdaten</a></li>
            <li><a [routerLink]="routes.users">Benutzer</a></li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
